import { Div, P } from '@kizi/core-components';
import { IconV2 } from '@kizi/shared-components';
import React from 'react';

export const SecureConnection = (props) => (
  <Div alignSelf="flex-end" {...props} display="flex" alignItems="center">
    <IconV2 name="lock" mr={2} variant="iconLink" fill="success" />
    <P variant={props?.variant ? props.variant : 'footnoteAdditionalInfo'}>
      {'Beveiligde verbinding'}
    </P>
  </Div>
);
